import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";
import Content from '../components/Content/Content';
import HeaderBar from '../components/HeaderBar/HeaderBar';
import SideMenu from '../components/Menu/SideMenu';
import { DrawerProvider } from '../providers/DrawerContext';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        backgroundColor: '#eef3ef',
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
        },
    },
}));

export default function Skeleton({ children }) {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CssBaseline />
            <DrawerProvider>
                <SideMenu />
                <HeaderBar />
                <Content>
                    {children}
                </Content>
            </DrawerProvider>
        </div>
    );
}
